import type { FC } from 'react'

import { Seo } from '@/components/generals/seo'
import { SiteShell } from '@/components/generals/site-shell'
import { PageHero } from '@/components/generals/page-hero'
import { studio } from '@/constants/dentea'

type LegalPageProps = {
    title: string
    roman: string
    italic: string
    summary: string
    updated: string
    sections: { heading: string; body: string[] }[]
}

/** Shared layout for the privacy and terms pages. */
export const LegalPage: FC<LegalPageProps> = ({ title, roman, italic, summary, updated, sections }) => {
    return (
        <>
            <Seo title={title} description={summary} />

            <SiteShell appointment={false}>
                <PageHero roman={roman} italic={italic} summary={summary} stacked />

                <div className='mx-auto flex w-full max-w-[760px] flex-col gap-12 px-5 pb-24 md:px-12 md:pb-32'>
                    <p className='label text-ink/45'>Last updated {updated}</p>

                    {sections.map((section) => (
                        <section key={section.heading} className='flex flex-col gap-4'>
                            <h2 data-anim='rise' data-anim-from='20' className='display text-[1.5rem] md:text-[2rem]'>
                                {section.heading}
                            </h2>

                            {section.body.map((paragraph) => (
                                <p key={paragraph} className='text-base leading-relaxed text-ink/80'>
                                    {paragraph}
                                </p>
                            ))}
                        </section>
                    ))}

                    <section className='flex flex-col gap-4 border-t border-ink/12 pt-10'>
                        <h2 className='display text-[1.5rem] md:text-[2rem]'>Contact us</h2>

                        <p className='text-base leading-relaxed text-ink/80'>
                            Questions about this page can be sent to{' '}
                            <a href={`mailto:${studio.email}`} className='text-ink underline underline-offset-4'>
                                {studio.email}
                            </a>{' '}
                            or posted to the studio at {studio.addressInline}.
                        </p>
                    </section>
                </div>
            </SiteShell>
        </>
    )
}
